module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-list', {
    staticClass: "person-detail",
    attrs: {
      "modifier": "noborder"
    }
  }, [_c('person-outline', {
    attrs: {
      "thing": _vm.destination
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47956247","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/destination/state/person.vue
// module id = 611
// module chunks = 0